import React, { useLayoutEffect, useEffect, useState, useRef} from "react";
import moment from 'moment';
import {FieldHolder} from "@/components/holders/FieldHolder";
import { PPCTimeField } from "@/components/datetime/PPCTimeField";
import { useTranslation, withTranslation, Trans } from "react-i18next";

export default function AddAppointmentPanel({...props}) {
    const { t, i18n, ready } = useTranslation();
    
    return (
        <>
<div className="grid grid-cols-4 items-start gap-2 pb-2">
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">{t("event.labels.location")}</label>
    <FieldHolder colspan="3" smcolspan="3"  id="location" error={null}>

        <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
              <input
                id="location"
                name="extra.appointment.location"
                defaultValue={((props.getValues("extra.appointment.location")) ? props.getValues("extra.appointment.location") : "")}
                type="text"
                placeholder={t("event.labels.location")}
                onChange={(event) => {props.setValue(event.target.name, event.target.value);}}
                className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
              />
        </div>
    </FieldHolder>
</div>

<div className="grid grid-cols-4 items-start gap-2 pb-2">
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">{t("event.labels.travelTime")}</label>
        <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
              <input
                id="distance"
                name="extra.appointment.distance"
                defaultValue={((props.getValues("extra.appointment.distance")) ? props.getValues("extra.appointment.distance") : "")}
                type="text"
                placeholder={t("event.labels.distance")}
                onChange={(event) => {props.setValue(event.target.name, event.target.value);}}
                className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
              />
        </div>

            <PPCTimeField onChange={(name, time) => {props.setValue(name, time);}} name="extra.appointment.traveltime"  hourCycle={24} defaultValue={props.getValues('extra.appointment.traveltime')}/>
</div>


        </>
    )
}